// Layouts
import DashboardLayout from 'src/pages/App/Layout/DashboardLayout.vue'
import PublicLayout from 'src/pages/App/Pages/Layout/PublicLayout.vue'
import GlimpsesLayout from 'src/pages/App/Pages/Layout/GlimpsesLayout.vue'

// GeneralViews
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'
import NotAccess from 'src/pages/GeneralViews/NotAccessPage.vue'

// Page Headers
const DashboardHeader = () => import(/* webpackChunkName: 'dashboard' */ 'src/pages/App/Dashboard/DashboardHeader.vue')
import DefaultHeader from 'src/pages/App/DefaultHeader'

// Dashboard pages
const AdminDashboard = () => import(/* webpackChunkName: 'dashboard' */ 'src/pages/App/Dashboard/Admin.vue')
const StudentDashboard = () => import(/* webpackChunkName: 'dashboard' */ 'src/pages/App/Dashboard/Student.vue')
const RegistrationDashboard = () => import(/* webpackChunkName: 'dashboard' */ 'src/pages/App/Dashboard/Registrations.vue')
const ProgrammeDashboard = () => import(/* webpackChunkName: 'dashboard' */ 'src/pages/App/Dashboard/Programme.vue')

import Widgets from 'src/pages/Dashboard/Widgets.vue'

// Public Pages
const Home = () =>  import(/* webpackChunkName: 'public' */ 'src/pages/App/Pages/Public/Home.vue')
const RegisterHome = () =>  import(/* webpackChunkName: 'public' */ 'src/pages/App/Pages/Public/RegisterHome.vue')
const RegisterProgramme = () =>  import(/* webpackChunkName: 'public' */ 'src/pages/App/Pages/Public/RegisterProgramme.vue')
const RegisterEvent = () =>  import(/* webpackChunkName: 'public' */ 'src/pages/App/Pages/Public/RegisterEvent.vue')
const PapersShowcase = () => import(/* webpackChunkName: 'public' */ 'src/pages/App/Pages/Public/PapersShowcase.vue')

// Public Glimpses Pages
const GlimpsesHome = () =>  import(/* webpackChunkName: 'public' */ 'src/pages/App/Pages/Glimpses/Home.vue')
const SingleNews = () =>  import(/* webpackChunkName: 'public' */ 'src/pages/App/Pages/Glimpses/News.vue')

// Authentication Pages
const Login = () => import(/* webpackChunkName: 'auth' */ 'src/pages/App/Pages/Auth/Login.vue')
const Forgot = () => import(/* webpackChunkName: 'auth' */ 'src/pages/App/Pages/Auth/Forgot.vue')
const Lock = () =>  import(/* webpackChunkName: 'auth' */ 'src/pages/App/Pages/Auth/Lock.vue')

// TableList pages

// App Pages
// Settings
// Roles
const RolesTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Settings/Roles/Manage.vue')
// Miscs
const MiscsTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Settings/Miscs/Manage.vue')

// CBCS
// Courses
const CoursesTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/CBCS/Courses/Manage.vue')
// Papers Manage
const PapersTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/CBCS/Papers/Manage.vue')
// Papers Compose
const PapersCompose = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/CBCS/Papers/Compose.vue')
// Papers Preview
const PapersPreview = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/CBCS/Papers/Preview.vue')


// Users
// Students
const StudentsTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Users/Students/Manage.vue')
// Teachers
const TeachersTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Users/Teachers/Manage.vue')

// Registrations
// Programmes
const ProgrammesWizard = () => import(/* webpackChunkName: 'view' */ 'src/pages/App/Registrations/Programmes/Wizard/Wizard.vue')
const ProgrammesList = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Registrations/Programmes/List.vue')
const ProgrammesDashboard = () => import(/* webpackChunkName: 'dashboard' */ 'src/pages/App/Registrations/Programmes/Dashboard.vue')
const ProgrammesView = () => import(/* webpackChunkName: 'view' */ 'src/pages/App/Registrations/Programmes/View.vue')
// Events
const EventsView = () => import(/* webpackChunkName: 'view' */ 'src/pages/App/Registrations/Events/View.vue')
//Registrations
const RegistrationsList = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Registrations/List.vue')

// Glimpses
// News
const NewsTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Glimpses/News/Manage.vue')
// Compose News
const ComposeNews = () => import(/* webpackChunkName: 'compose' */ 'src/pages/App/Glimpses/News/Compose.vue')
// Preview News
const PreviewNews = () => import(/* webpackChunkName: 'compose' */ 'src/pages/App/Glimpses/News/Compose.vue')
// Newsletters
const NewslettersTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Glimpses/Newsletters/Manage.vue')
// Compose Newsletter
const ComposeNewsletter = () => import(/* webpackChunkName: 'compose' */ 'src/pages/App/Glimpses/Newsletters/Compose.vue')
// Preview Newsletter
const PreviewNewsletter = () => import(/* webpackChunkName: 'view' */ 'src/pages/App/Glimpses/Newsletters/Preview.vue')
// Notifications
const NotificationsTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Glimpses/Notifications/Manage.vue')
// Notices
const NoticesTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Glimpses/Notices/Manage.vue')
// Compose Notice
const ComposeNotice = () => import(/* webpackChunkName: 'compose' */ 'src/pages/App/Glimpses/Notices/Compose.vue')
// Today
const TodayTables = () => import(/* webpackChunkName: 'tables' */ 'src/pages/App/Glimpses/Today/Manage.vue')
// Compose Today
const ComposeToday = () => import(/* webpackChunkName: 'compose' */ 'src/pages/App/Glimpses/Today/Compose.vue')

// Reports
// View
const ReportsView = () => import(/* webpackChunkName: 'view' */ 'src/pages/App/Reports/View.vue')
const ReportsSubscriptions = () => import(/* webpackChunkName: 'view' */ 'src/pages/App/Reports/Subscriptions.vue')

// Profile
// User Profile
const UserProfile = () => import(/* webpackChunkName: 'view' */ 'src/pages/App/Profile/UserProfile.vue')

// Demo
// Charts Demo
const ChartsDemo = () => import(/* webpackChunkName: 'view' */ 'src/pages/Dashboard/Charts.vue')


// App Pages
// Authentication
let AuthPages = {
  path: '/auth',
  component: PublicLayout,
  redirect: '/auth/login',
  name: 'Auth',
  meta: {
    auth: false,
    roles: []
  },
  children: [
    {
      path: 'login',
      name: 'Login',
      component: Login,
    },
    { 
        path: 'logout',
        name: 'Logout', 
        component: Login
    },
    {
      path: 'forgot',
      name: 'Forgot',
      component: Forgot,
    },
    {
      path: 'lock',
      name: 'Lock',
      component: Lock
    }
  ]
}

// Settings
let SettingsPages = {
  path: '/settings',
  component: DashboardLayout,
  redirect: '/settings/roles',
  name: 'Settings',
  children: [
    {
      path: 'roles',
      name: 'Roles',
      components: { default: RolesTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'miscs',
      name: 'Miscs',
      components: { default: MiscsTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
  ],
  meta: {
    auth: true
  },
}

// CBCS
let CBCSPages = {
  path: '/CBCS',
  component: DashboardLayout,
  redirect: '/CBCS/courses',
  name: 'CBCS',
  children: [
    {
      path: 'courses',
      name: 'Programmes',
      components: { default: CoursesTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'papers/manage',
      name: 'Courses',
      components: { default: PapersTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'papers/compose',
      name: 'Courses Compose',
      components: { default: PapersCompose, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'papers/edit/:slug',
      name: 'Courses Edit',
      components: { default: PapersCompose, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'papers/preview/:slug',
      name: 'Courses Preview',
      components: { default: PapersPreview, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'student']
      },
    },
  ],
  meta: {
    auth: true
  },
}

// Users
let UsersPages = {
  path: '/users',
  component: DashboardLayout,
  redirect: '/users/students',
  name: 'Users',
  children: [
    {
      path: 'students',
      name: 'Students',
      components: { default: StudentsTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'teachers',
      name: 'Teachers',
      components: { default: TeachersTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
  ],
  meta: {
    auth: true
  },
}

// Programmes
let ProgrammesPages = {
  path: '/programmes',
  component: DashboardLayout,
  redirect: '/programmes/list',
  name: 'Registration Programmes',
  children: [
    {
      path: 'create',
      name: 'Programme Create',
      components: { default: ProgrammesWizard, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'edit/:slug',
      name: 'Programme Edit',
      components: { default: ProgrammesWizard, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'view/:slug',
      name: 'Programme View',
      components: { default: ProgrammesView, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'student', 'teacher']
      },
    },
    {
      path: 'view/:slug/:batch',
      name: 'Programme View Batchwise',
      components: { default: ProgrammesView, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'teacher']
      },
    },
    {
      path: 'list',
      name: 'Programmes List',
      components: { default: ProgrammesList, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'dashboard',
      name: 'Active Programmes Dashboard',
      components: { default: ProgrammesDashboard, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'dashboard/:slug',
      name: 'Programme Dashboard',
      components: { default: ProgrammeDashboard, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
  ],
  meta: {
    auth: true
  },
}

// Events
let EventsPages = {
  path: '/events',
  component: DashboardLayout,
  redirect: '/events/list',
  name: 'Events',
  children: [
    {
      path: 'view/:slug',
      name: 'Event View',
      components: { default: EventsView, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'student', 'teacher']
      },
    },
  ],
  meta: {
    auth: true
  },
}

// Dashboard Pages
let DashboardPages = {
  path: '/dashboard',
  component: DashboardLayout,
  name: 'Dashboard',
  redirect: '/auth/login',
  meta: {
    auth: true,
  },
  children: [
    {
      path: 'charts',
      name: 'Charts Demo',
      components: { default: ChartsDemo, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'student', 'teacher']
      },
    },
    {
      path: 'profile',
      name: 'User Profile',
      components: { default: UserProfile, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'student', 'teacher']
      },
    },
    {
      path: 'admin',
      name: 'Admin Dashboard',
      components: { default: AdminDashboard, header: DashboardHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'teacher',
      name: 'Teacher Dashboard',
      components: { default: AdminDashboard, header: DashboardHeader },
      meta: {
        auth: true,
        roles: ['teacher']
      },
    },
    {
      path: 'student',
      name: 'Student Dashboard',
      components: { default: StudentDashboard, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin','student']
      },
    }
  ]
}

// Public Pages
let PublicPages = {
  path: '/',
  component: PublicLayout,
  redirect: '/home',
  name: 'Public',
  meta: {
    auth: false,
    roles: []
  },
  children: [
    {
      path: 'home',
      name: 'Home',
      component: Home
    },
    {
      path: 'events',
      name: 'Events Home',
      component: RegisterHome
    },
    {
      path: 'register-:slug',
      name: 'Register Programme',
      component: RegisterProgramme,
    },
    {
      path: 'event-:slug',
      name: 'Register Event',
      component: RegisterEvent,
    },
    {
      path: 'papers-:slug',
      name: 'Courses Showcase',
      component: PapersShowcase,
    },
    {
      path: 'not-found',
      name: '404',
      component: NotFound
    },
    {
      path: 'no-access',
      name: 'No Access',
      component: NotAccess
    }
  ]
}

// Public Glimpses Pages
let PublicGlimpsesPages = {
  path: '/www/glimpses',
  component: GlimpsesLayout,
  redirect: '/www/glimpses/home',
  name: 'Public Glimpses',
  meta: {
    auth: false,
    roles: []
  },
  children: [
    {
      path: 'home',
      name: 'Glimpses Home',
      component: GlimpsesHome
    },
    {
      path: 'home/:volume/:issue',
      name: 'Home VI',
      component: GlimpsesHome
    },
    {
      path: 'news/:slug',
      name: 'Single News',
      component: SingleNews
    }
  ]
}

let RegistrationPages = {
  path: '/registrations',
  component: DashboardLayout,
  redirect: '/view',
  name: 'Registrations',
  meta: {
    auth: true,
    roles: ['admin', 'student']
  },
  children: [
    {
      path: 'dashboard/:slug',
      name: 'Registrations Dashboard',
      components: { default: RegistrationDashboard, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'view',
      name: 'View Registrations',
      components: { default: RegistrationsList, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['student']
      },
    },
    {
      path: 'view/programme/:slug',
      name: 'View Programme Registrations',
      components: { default: RegistrationsList, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'view/event/:slug',
      name: 'View Event Registrations',
      components: { default: RegistrationsList, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    }
  ]
}

// Glimpses
// News
let GlimpsesNewsPages = {
  path: '/glimpses/news',
  component: DashboardLayout,
  redirect: '/glimpses/news/manage',
  name: 'Glimpses News',
  children: [
    {
      path: 'manage',
      name: 'News Manage',
      components: { default: NewsTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'author', 'editor']
      }
    },
    {
      path: 'compose',
      name: 'News Compose',
      components: { default: ComposeNews, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'author', 'editor']
      },
    },
    {
      path: 'view/:id',
      name: 'View News',
      components: { default: PreviewNews, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'author', 'editor']
      }
    },
    {
      path: 'edit/:id',
      name: 'News Edit',
      components: { default: ComposeNews, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'author', 'editor']
      }
    }
  ],
  meta: {
    auth: true
  },
}
// Newsletters
let GlimpsesNewsletterPages = {
  path: '/glimpses/newsletters',
  component: DashboardLayout,
  redirect: '/glimpses/newsletters/manage',
  name: 'Glimpses Newsletters',
  children: [
    {
      path: 'manage',
      name: 'Glimpses Manage',
      components: { default: NewslettersTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    {
      path: 'compose/:volume',
      name: 'Glimpses Compose',
      components: { default: ComposeNewsletter, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'view/:id',
      name: 'Glimpses View',
      components: { default: PreviewNewsletter, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    {
      path: 'edit/:id',
      name: 'Glimpses Edit',
      components: { default: ComposeNewsletter, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      }
    }
  ],
  meta: {
    auth: true
  },
}
// Notifications
let GlimpsesNotificationPages = {
  path: '/glimpses/notifications',
  component: DashboardLayout,
  redirect: '/glimpses/notifications/manage',
  name: 'Glimpses Notifications',
  children: [
    {
      path: 'manage',
      name: 'Notifications Manage',
      components: { default: NotificationsTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      }
    }
  ],
  meta: {
    auth: true
  },
}
// Notices
let GlimpsesNoticesPages = {
  path: '/glimpses/notices',
  component: DashboardLayout,
  redirect: '/glimpses/notices/manage',
  name: 'Glimpses Notices',
  children: [
    {
      path: 'manage',
      name: 'Circulars Manage',
      components: { default: NoticesTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    {
      path: 'compose',
      name: 'Circulars Compose',
      components: { default: ComposeNotice, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'edit/:date',
      name: 'Circulars Edit',
      components: { default: ComposeNotice, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      }
    }
  ],
  meta: {
    auth: true
  },
}
// KJC Today
let GlimpsesTodayPages = {
  path: '/glimpses/today',
  component: DashboardLayout,
  redirect: '/glimpses/today/manage',
  name: 'Glimpses Today',
  children: [
    {
      path: 'manage',
      name: 'Today Manage',
      components: { default: TodayTables, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      }
    },
    {
      path: 'compose',
      name: 'Today Compose',
      components: { default: ComposeToday, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      },
    },
    {
      path: 'edit/:date',
      name: 'Today Edit',
      components: { default: ComposeToday, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin']
      }
    }
  ],
  meta: {
    auth: true
  },
}

// Reports
let ReportsPages = {
  path: '/reports',
  component: DashboardLayout,
  redirect: '/reports/view',
  name: 'Reports',
  children: [
    {
      path: 'view',
      name: 'Reports View',
      components: { default: ReportsView, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'teacher']
      }
    },
    {
      path: 'subscriptions',
      name: 'Reports Subscriptions',
      components: { default: ReportsSubscriptions, header: DefaultHeader },
      meta: {
        auth: true,
        roles: ['admin', 'teacher']
      }
    }
  ],
  meta: {
    auth: true
  }
}

const routes = [
  AuthPages,
  CBCSPages,
  UsersPages,
  PublicGlimpsesPages,
  PublicPages,
  EventsPages,
  SettingsPages,
  DashboardPages,
  ProgrammesPages,  
  RegistrationPages,
  GlimpsesNewsPages,
  GlimpsesNewsletterPages,
  GlimpsesNotificationPages,
  GlimpsesNoticesPages,
  GlimpsesTodayPages,
  ReportsPages,
  { 
    path: '*', 
    redirect: '/not-found'
  }
]

export default routes
